
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/overview",
      function () {
        return require("private-next-pages/company/overview.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company/overview"])
      });
    }
  